/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DailyTaskGroupDto } from './DailyTaskGroupDto';
import {
    DailyTaskGroupDtoFromJSON,
    DailyTaskGroupDtoFromJSONTyped,
    DailyTaskGroupDtoToJSON,
    DailyTaskGroupDtoToJSONTyped,
} from './DailyTaskGroupDto';

/**
 * 
 * @export
 * @interface DailyTaskSlotDto
 */
export interface DailyTaskSlotDto {
    /**
     * 
     * @type {string}
     * @memberof DailyTaskSlotDto
     */
    slot: DailyTaskSlotDtoSlotEnum;
    /**
     * 
     * @type {string}
     * @memberof DailyTaskSlotDto
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof DailyTaskSlotDto
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof DailyTaskSlotDto
     */
    endTime: string;
    /**
     * 
     * @type {Array<DailyTaskGroupDto>}
     * @memberof DailyTaskSlotDto
     */
    taskGroups: Array<DailyTaskGroupDto>;
}


/**
 * @export
 */
export const DailyTaskSlotDtoSlotEnum = {
    Morning: 'morning',
    Midday: 'midday',
    Evening: 'evening',
    Bedtime: 'bedtime'
} as const;
export type DailyTaskSlotDtoSlotEnum = typeof DailyTaskSlotDtoSlotEnum[keyof typeof DailyTaskSlotDtoSlotEnum];


/**
 * Check if a given object implements the DailyTaskSlotDto interface.
 */
export function instanceOfDailyTaskSlotDto(value: object): value is DailyTaskSlotDto {
    if (!('slot' in value) || value['slot'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('taskGroups' in value) || value['taskGroups'] === undefined) return false;
    return true;
}

export function DailyTaskSlotDtoFromJSON(json: any): DailyTaskSlotDto {
    return DailyTaskSlotDtoFromJSONTyped(json, false);
}

export function DailyTaskSlotDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyTaskSlotDto {
    if (json == null) {
        return json;
    }
    return {
        
        'slot': json['slot'],
        'displayName': json['displayName'],
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'taskGroups': ((json['taskGroups'] as Array<any>).map(DailyTaskGroupDtoFromJSON)),
    };
}

export function DailyTaskSlotDtoToJSON(json: any): DailyTaskSlotDto {
    return DailyTaskSlotDtoToJSONTyped(json, false);
}

export function DailyTaskSlotDtoToJSONTyped(value?: DailyTaskSlotDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slot': value['slot'],
        'displayName': value['displayName'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'taskGroups': ((value['taskGroups'] as Array<any>).map(DailyTaskGroupDtoToJSON)),
    };
}

